import Axios from 'axios';
import {
    Message
} from 'element-ui';
import store from '../store/index'
import router from '../router/index'
const fetch = Axios.create({
    // withCredentials: true,
    // baseURL: 'http://101.132.152.242:8000/',
    baseURL: "https://www.hblcyx.cn/"
})

fetch.interceptors.request.use(config => {
    const token = localStorage.getItem('token')
    if (token) { // 将令牌添加到header是里
        config.headers.token = token;
    }
    return config
})

// 添加响应拦截器
fetch.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    if (response.data.code != 200 || response.status != 200) {
        if (response.data.code == 403 || response.status == 403 || response.data.code == 401 || response.status == 401) {
            Message.error('未登录');
            store.commit("reset");
            router.push('/login')
        } else if (response.data.code == 300) {
            Message.error(response.data.msg);
            store.commit("reset");
            router.push('/login')
            // return Promise.reject(response);
        }
    }
    if(response.data.code == 9000) {
      Message.error(response.data.msg);
      return Promise.reject(response.data);
    }
    // console.log(response)
    return response.data;
}, function (error) {
    // console.log(error.data);
    Message.error('服务器错误，请联系管理员');
    // 对响应错误做点什么
    return Promise.reject(error);
});

export default fetch;